import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Home from './pages/home/Home';
import { ThemeProvider } from './hooks/ThemeContext';
import Background from './components/Background';
import Navbar from './components/Navbar';
import Login from './pages/login/login';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <Background>
        <App></App>

      </Background>
    </ThemeProvider>
    {/* <App /> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
